module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/logo/logo-full-260.png"+" 260w",
        images: [{path: __webpack_public_path__ + "assets/images/logo/logo-full-260.png",width: 260,height: 91}],
        src: __webpack_public_path__ + "assets/images/logo/logo-full-260.png",
        toString: function(){return __webpack_public_path__ + "assets/images/logo/logo-full-260.png"},
        
        width: 260,
        height: 91
      }